﻿import React from 'react';

import {
    DynamicFormToggleableRow,
    connectToggleable
} from './DynamicFormToggleableRow';

import {
    Level3RowContainer,
    DynamicFormLevel2Row
} from '../Styles/dynamicFormStyles';

import DynamicFormLevel3QuestionRow from './DynamicFormLevel3QuestionRow';

import {repeatableIdSeparator} from '../constants';

class DynamicFormLevel2QuestionRow extends DynamicFormToggleableRow {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;
        let questionGroup = this.props.questionGroup;

        const isRepeated = this.props.isRepeated;
        const repeatCount = this.props.repeatCount;

        const questionGroupId = isRepeated
            ? `${questionGroup.id}${repeatableIdSeparator}${repeatCount}`
            : questionGroup.id;

        if(isRepeated) {
            questionGroup = {
                ...questionGroup,
                id: questionGroupId
            }
        }

        const subQuestionGroup = this.props.questionGroup.subQuestionGroup;

        return (
            <DynamicFormLevel2Row displayValue={this.props.displayValue} styleForConfirmView={this.props.currentStep === 1}>
                <QuestionTypeHandler
                    question={questionGroup}
                    formInput={this.props.formInputs[questionGroupId]}
                    toggleSubQuestions={this.toggleSubQuestions}
                />
                <Level3RowContainer displayValue={this.state.subQuestionVisibility && subQuestionGroup ? 'block' : 'none'}>
                    {subQuestionGroup && this.state.subQuestionVisibility &&
                        subQuestionGroup.questions.map(group => (
                            <DynamicFormLevel3QuestionRow
                                key={group.id}
                                formInput={this.props.formInputs[group.id]}
                                questionGroup={group}
                                questionTypeHandler={QuestionTypeHandler}
                            />
                        ))
                    }
                </Level3RowContainer>
            </DynamicFormLevel2Row>
        );
    }
}

export default connectToggleable(DynamicFormLevel2QuestionRow);
